/**
 * Intern verkeer: ons eigen kijken naar de site buiten de cijfers houden.
 *
 * Waarom: Thijs, Taco en ik (bij het verifiëren van een wijziging) bezoeken de site vaker en
 * langer dan een klant. In GA4 telt dat gewoon mee — het drukt het conversiepercentage en blaast
 * pagina's op die niemand anders bekijkt. Gemeten 20-09-2026: 66 "gebruikers" uit Singapore met
 * 0 seconden op de site (scrapers) plus 11 uit Indonesië met 4,5 minuut per bezoek (mijn tests).
 *
 * Hoe: één keer `glastotaal.nl/?intern=1` openen in de browser waarmee je kijkt. Dat zet een vlag
 * in localStorage; vanaf dan krijgt elke GA4-hit `traffic_type: "internal"` mee, en het
 * gegevensfilter "Intern verkeer" in GA4 gooit die eruit. Uitzetten: `/?intern=0`.
 *
 * Bewust GEEN IP-filter (de standaardmanier van GA4): thuis-, kantoor- en mobiele IP's veranderen,
 * en mijn testverkeer komt uit wisselende datacenters. Een vlag in de browser is stabiel.
 *
 * Automatisch: wie in de admin inlogt, krijgt de vlag in díe browser (markeerIntern, aangeroepen
 * vanuit useAdminAuth). Thijs en Taco hoeven dus niets te doen; ze kijken op de webshop met dezelfde
 * browser waarin ze de admin gebruiken.
 *
 * Let op: dit is puur een meetvlag. Hij verandert niets aan prijzen, rechten of wat de site toont.
 */
const KEY = "glastotaal.intern";

/** Leest `?intern=1` / `?intern=0` uit de URL en onthoudt de keuze. Retourneert de huidige stand. */
export function internVerkeer(search?: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    const param = new URLSearchParams(search ?? window.location.search).get("intern");
    if (param === "1" || param === "true") localStorage.setItem(KEY, "1");
    else if (param === "0" || param === "false") localStorage.removeItem(KEY);
    return localStorage.getItem(KEY) === "1";
  } catch {
    // Geen storage (privémodus) → gewoon meten als bezoeker; meten mag nooit stukgaan hierop.
    return false;
  }
}

/**
 * Deze browser voortaan als intern meten (aangeroepen zodra iemand als beheerder is ingelogd).
 * Zet de vlag én meldt het meteen aan gtag, zodat ook de events van dit bezoek al intern zijn —
 * de `config` met traffic_type is op dat moment immers al gestuurd.
 */
export function markeerIntern(): void {
  if (typeof window === "undefined") return;
  try {
    if (localStorage.getItem(KEY) === "1") return;
    localStorage.setItem(KEY, "1");
  } catch {
    return; // geen storage → volgende paginaladen zou het toch vergeten
  }
  try {
    (window as { gtag?: (...a: unknown[]) => void }).gtag?.("set", { traffic_type: "internal" });
  } catch {
    /* gtag afwezig/geblokkeerd — de vlag staat, vanaf de volgende paginalading telt hij */
  }
}
